import template from './ko-field-input-image.html';

class IMGInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.help_text = ko.observable(params.help_text);
	}
}

export default {
	name: 'ko-field-input-image',
	viewModel: IMGInputComponentVM,
	module_type: 'ko',
	template: template
} 
